import { FAVICON_IMG } from '../../../config/constants';

export { resolveServerSideProps } from './resolve-server-side-props.util';

export const getDateDiffInDays = (a: Date, b: Date): number => {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};

export const getDateDiffInHours = (a: Date, b: Date): number => {
  return Math.ceil(Math.abs(b.getTime() - a.getTime()) / 3600000);
};

export const getCurrentFiscalYear = (): string => {
  const today = new Date();
  const curMonth = today.getMonth();
  if (curMonth >= 3) return `${today.getFullYear()}-${today.getFullYear() + 1}`;
  return `${today.getFullYear() - 1}-${today.getFullYear()}`;
};

export const getCurrencyFromUnicode = (code: string): string => {
  let symbol = '₹';
  if (code) {
    symbol = String.fromCodePoint(parseInt(code.slice(2), 16));
  }
  return symbol;
};

export const getCommaFormat = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  const returnVal =
    typeof value === 'number' ? value.toLocaleString('en-IN') : value;

  return `${returnVal}`;
};
export const getApiParamsString = <T extends unknown>(params: T): string => {
  if (!(params && Object.keys(params) && Object.keys(params).length)) return '';
  return Object.entries(params)
    .map(([k, v]) => `${k}=${encodeURIComponent(`${v}`)}`)
    .join('&');
};
export const getPageLoader = () => {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center backdrop-blur-md overflow-hidden">
      <img
        src={FAVICON_IMG}
        alt="favicon"
        className="animate-bounce w-16 h-16"
      />
    </div>
  );
};

export const productFromProctServiceType = (productServiceType: string) => {
  try {
    return productServiceType.split('-')[0];
  } catch (e) {
    return 'MP';
  }
};
export const debounce = (fn: Function, ms = 300) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

export const throttle = (fn: Function, wait: number = 300) => {
  let inThrottle: boolean,
    lastFn: ReturnType<typeof setTimeout>,
    lastTime: number;
  return function (this: any) {
    const context = this,
      args = arguments;
    if (!inThrottle) {
      fn.apply(context, args);
      lastTime = Date.now();
      inThrottle = true;
    } else {
      clearTimeout(lastFn);
      lastFn = setTimeout(() => {
        if (Date.now() - lastTime >= wait) {
          fn.apply(context, args);
          lastTime = Date.now();
        }
      }, Math.max(wait - (Date.now() - lastTime), 0));
    }
  };
};

export const randomIntFromInterval = (min: number, max: number) => {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
};
